import { render, staticRenderFns } from "./AdminReferral.vue?vue&type=template&id=6983215e&scoped=true"
import script from "./AdminReferral.vue?vue&type=script&lang=js"
export * from "./AdminReferral.vue?vue&type=script&lang=js"
import style0 from "./AdminReferral.vue?vue&type=style&index=0&id=6983215e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6983215e",
  null
  
)

export default component.exports